import React, { useState } from 'react'
import { AgreementPreviousVersionsProps } from './AgreementPreviousVersions.types'
import styles from './AgreementPreviousVersions.module.scss'
import cl from 'classnames'
import { Button, HorizontalLine, Text1 } from 'components/shared'
import { IconDelete } from 'assets'
import { Select } from 'components/shared/Select'
import { getSortingResult, SortDirection, useOutsideClick } from 'utilities'
import { AgreementPrevVersionListItem } from './AgreementPrevVersionListItem'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'

const AgreementPreviousVersionsComponent = (props: AgreementPreviousVersionsProps) => {
  const {
    className,
    style,
    closeWindow,
    [AGREEMENT_PAGE_STORE]: {
      prevVersions
    }
  } = props

  const [sortDirection, setSortDirection] = useState<SortDirection>(SortDirection.ASC)

  const ref = useOutsideClick(closeWindow)

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
      ref={ref}
    >
      <div className={styles.header}>
        <Text1 bold className={styles.heading}>Versions</Text1>
        <Button
          preset='icon'
          className={styles.closeButton}
          onClick={closeWindow}
        >
          <IconDelete width={12} height={12} />
        </Button>
        <HorizontalLine style={{ marginTop: 5 }} />
        <div className={styles.sortingContainer}>
          <Text1 className={styles.sortByText}>Sort by:</Text1>
          <Select<SortDirection>
            options={[
              {
                label: 'Recent to oldest',
                value: SortDirection.ASC
              },
              {
                label: 'Oldest to recent',
                value: SortDirection.DESC
              }
            ]}
            value={sortDirection}
            onChange={setSortDirection}
            noNoneOption
            className={styles.sortSelect}
          />
        </div>
      </div>

      <div
        className={cl(styles.listContainer, styles.scrollable, {
          [styles.reverseOrder]: sortDirection === SortDirection.DESC
        })}
      >
        {prevVersions
          .sort((a, b) => getSortingResult(a.createdDate, b.createdDate, SortDirection.ASC))
          .map((agreement, index) => {
            return (
              <AgreementPrevVersionListItem
                key={agreement.id}
                agreementName={agreement.name}
                createdDate={agreement.createdDate}
                updatedBy={agreement.updatedBy}
                versionNumber={index + 1}
              />
            )
          })}
      </div>
    </div>
  )
}

const AgreementPreviousVersions = inject(
  AGREEMENT_PAGE_STORE
)(observer(AgreementPreviousVersionsComponent))
export { AgreementPreviousVersions }
